export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const IMAGES_URL = "https://cdn.meucupom.com"

export const LOGO_HOTAREA = `${IMAGES_URL}/uploads/custom-category-images/`

export const HEADER_HOTAREA = `${IMAGES_URL}/uploads/custom-header-images/`

export const STORE_IMAGES = `${IMAGES_URL}/store_logos/`

export const BASE_CDN_URL = "https://cdn.meucupom.com/app-assets/5.07.51/novomc/assets/images/";

export const DEFAULT_BANNER = `${BASE_CDN_URL}fundo.png`;

export const MEUCUPOM_URL = "https://www.meucupom.com";

export const CASHBACK_ICON = "https://static.meucupom.com/media/2026%20-%20Updates/Cashback_icon_negativo-01%20(1).png";